document.addEventListener("DOMContentLoaded", function() {
  window.addEventListener("message", function(event) {
    if (event.origin.includes("revenuehunt") && event.type === "message") {
      var data;
      
      try {
        data = JSON.parse(event.data);
      } catch (e) {
        return;
      }
    
      if (typeof data === "object" && typeof data.action === "string") {
        if (data.action === "quiz_recommendation_product" && data.recommended_product) {
          console.log(data.recommended_product);
          dataLayer.push({
            event: "diagnostic_recommendation_product",
            recommended_product: data.recommended_product,
          });
        }
      }
    }
  });
});